// extracted by mini-css-extract-plugin
export default {"columnsList":"TableFormColumns_columnsList__5GPxM","indexesList":"TableFormColumns_indexesList__F16kB","columnWrapper":"TableFormColumns_columnWrapper__f9MnC"};